var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSbpButton = function SvgSbpButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 24,
    fill: "#fff",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#12103A",
    fillRule: "evenodd",
    d: "M33.788 15.6c1.88 0 3.275-1.152 3.275-2.9 0-1.69-1.03-2.788-2.75-2.788-.794 0-1.45.28-1.944.762.118-.997.962-1.725 1.89-1.725l1.827-.003.912-1.746s-2.025.046-2.966.046c-2.151.038-3.604 1.993-3.604 4.367 0 2.767 1.417 3.987 3.36 3.987m.012-4.142c.698 0 1.181.459 1.181 1.243 0 .705-.43 1.287-1.181 1.288-.72 0-1.203-.539-1.203-1.276 0-.785.484-1.255 1.203-1.255",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#12103A",
    d: "M44.32 15.39h-2.099v-4.125H40.2v4.125h-2.1V9.51h6.22zM27.483 13.761c.74-.054 1.236-.34 1.236-.34l.777 1.438c-.497.32-1.314.527-1.906.55-2.117.038-3.59-1.25-3.59-3.127 0-1.854 1.567-3.173 3.59-3.173.802 0 1.491.215 2.009.607-.283.501-.829 1.502-.829 1.502s-.745-.39-1.309-.39c-.919 0-1.588.534-1.588 1.466 0 .955.758 1.493 1.61 1.467"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B57A2",
    d: "m3.6 5.594 2.778 4.967v3.029l-2.775 4.957z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D90751",
    d: "m14.268 8.753 2.603-1.596 5.328-.005-7.931 4.86z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB718",
    d: "m14.253 5.565.014 6.575-2.785-1.711V.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED6F26",
    d: "m22.2 7.153-5.33.005-2.617-1.593L11.483.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#63B22F",
    d: "M14.267 18.574v-3.19l-2.785-1.679.002 9.839z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1487C9",
    d: "M16.865 16.993 6.378 10.56 3.6 5.594l18.588 11.392z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#017F36",
    d: "m11.484 23.544 2.783-4.97 2.597-1.581 5.324-.007z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#984995",
    d: "m3.604 18.546 7.902-4.84-2.657-1.63-2.47 1.514z"
  })));
};
export default SvgSbpButton;